import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const Impressum = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen w-screen bg-white dark:bg-zinc-900 transition-colors duration-300">
      <section className="w-full py-12 px-4 md:px-12 lg:px-24">
        <div className="w-full max-w-4xl mx-auto">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-8">
            {t('impressum.title')}
          </h1>
          
          <div className="prose prose-lg dark:prose-invert max-w-none">
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">
                {t('impressum.responsiblePerson')}
              </h2>
              <p className="text-gray-700 dark:text-gray-300">
                Petra-Maria Mebes<br />
                Straße: Schmidstraße 27<br />
                Ort: 85399 Hallbergmoos
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">
                {t('impressum.contact')}
              </h2>
              <p className="text-gray-700 dark:text-gray-300">
                Kontakt: <a href="mailto:info@atelierpeart.com" className="text-blue-600 dark:text-blue-400 hover:underline">info@atelierpeart.com</a><br />
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">
                {t('impressum.liabilityContent')}
              </h2>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                {t('impressum.liabilityContentText1')}
              </p>
              <p className="text-gray-700 dark:text-gray-300">
                {t('impressum.liabilityContentText2')}
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">
                {t('impressum.liabilityLinks')}
              </h2>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                {t('impressum.liabilityLinksText1')}
              </p>
              <p className="text-gray-700 dark:text-gray-300">
                {t('impressum.liabilityLinksText2')}
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">
                {t('impressum.copyright')}
              </h2>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                {t('impressum.copyrightText1')}
              </p>
              <p className="text-gray-700 dark:text-gray-300">
                {t('impressum.copyrightText2')}
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">
                {t('impressum.source')}
              </h2>
              <p className="text-gray-700 dark:text-gray-300">
                <a href="https://www.e-recht24.de" target="_blank" rel="noopener noreferrer" className="text-blue-600 dark:text-blue-400 hover:underline">
                  www.e-recht24.de
                </a>
              </p>
            </section>
          </div>

          <div className="mt-12">
            <Link 
              to="/" 
              className="text-blue-600 dark:text-blue-400 hover:underline text-lg"
            >
              ← {t('impressum.backToHome')}
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Impressum;